export default "__VITE_ASSET__DyoIJcDY__"